import { AIDA } from 'src/assets/icons/cards/AIDA';
import { AmazonProductListing } from 'src/assets/icons/cards/AmazonProductListing';
import { Article } from 'src/assets/icons/cards/Article';
import { BlogPostTopicIdes } from 'src/assets/icons/cards/BlogPostTopicIdes';
import { BlogWizard } from 'src/assets/icons/cards/BlogWizard';
import { ContentImprover } from 'src/assets/icons/cards/ContentImprover';
import { Email } from 'src/assets/icons/cards/Email';
import { EmailSubjectLine } from 'src/assets/icons/cards/EmailSubjectLine';
import { FacebookAd } from 'src/assets/icons/cards/FacebookAd';
import { FacebookPost } from 'src/assets/icons/cards/FacebookPost';
import { FifthGrader } from 'src/assets/icons/cards/FifthGrader';
import { GeneralProductListing } from 'src/assets/icons/cards/GeneralProductListing';
import { GoogleRSA } from 'src/assets/icons/cards/GoogleRSA';
import { GoogleSearchAdDescription } from 'src/assets/icons/cards/GoogleSearchAdDescription';
import { GoogleSearchHeadline } from 'src/assets/icons/cards/GoogleSearchHeadline';
import { ImageWithDescription } from 'src/assets/icons/cards/ImageWithDescription';
import { InstagramCaption } from 'src/assets/icons/cards/InstagramCaption';
import { LandingPageBenefits } from 'src/assets/icons/cards/LandingPageBenefits';
import { LandingPageCTA } from 'src/assets/icons/cards/LandingPageCTA';
import { LandingPageFeatures } from 'src/assets/icons/cards/LandingPageFeatures';
import { LandingPageHeadline } from 'src/assets/icons/cards/LandingPageHeadline';
import { LandingPageSubheader } from 'src/assets/icons/cards/LandingPageSubheader';
import { LinkedinAd } from 'src/assets/icons/cards/LinkedinAd';
import { LinkedinPost } from 'src/assets/icons/cards/LinkedinPost';
import { LongFormSavedTemplate } from 'src/assets/icons/cards/LongFormSavedTemplate';
import { NewDocument } from 'src/assets/icons/cards/NewDocument';
import { OutbarainAdHeadline } from 'src/assets/icons/cards/OutbarainAdHeadline';
import { PAS } from 'src/assets/icons/cards/PAS';
import { PerfectProductHeadline } from 'src/assets/icons/cards/PerfectProductHeadline';
import { PinterestAd } from 'src/assets/icons/cards/PinterestAd';
import { PinterestPinDescription } from 'src/assets/icons/cards/PinterestPinDescription';
import { PinterestPinTitle } from 'src/assets/icons/cards/PinterestPinTitle';
import { ProductLandingPage } from 'src/assets/icons/cards/ProductLandingPage';
import { ProductLaunchCampaign } from 'src/assets/icons/cards/ProductLaunchCampaign';
import { ProductReview } from 'src/assets/icons/cards/ProductReview';
import { PromotionalSMS } from 'src/assets/icons/cards/PromotionalSMS';
import { Prompt } from 'src/assets/icons/cards/Prompt';
import { SentenceExpander } from 'src/assets/icons/cards/SentenceExpander';
import { SEOMetaDescription } from 'src/assets/icons/cards/SEOMetaDescription';
import { ShortFormSavedTemplate } from 'src/assets/icons/cards/ShortFormSavedTemplate';
import { AIDA as SmallAIDA } from 'src/assets/icons/cards/small/AIDA';
import { AmazonProductListing as SmallAmazonProductListing } from 'src/assets/icons/cards/small/AmazonProductListing';
import { Article as SmallArticle } from 'src/assets/icons/cards/small/Article';
import { BlogPostTopicIdes as SmallBlogPostTopicIdes } from 'src/assets/icons/cards/small/BlogPostTopicIdes';
import { BlogWizard as SmallBlogWizard } from 'src/assets/icons/cards/small/BlogWizard';
import { ContentImprover as SmallContentImprover } from 'src/assets/icons/cards/small/ContentImprover';
import { Email as SmallEmail } from 'src/assets/icons/cards/small/Email';
import { EmailSubjectLine as SmallEmailSubjectLine } from 'src/assets/icons/cards/small/EmailSubjectLine';
import { FacebookAd as SmallFacebookAd } from 'src/assets/icons/cards/small/FacebookAd';
import { FacebookPost as SmallFacebookPost } from 'src/assets/icons/cards/small/FacebookPost';
import { FifthGrader as SmallFifthGrader } from 'src/assets/icons/cards/small/FifthGrader';
import { GeneralProductListing as SmallGeneralProductListing } from 'src/assets/icons/cards/small/GeneralProductListing';
import { GoogleRSA as SmallGoogleRSA } from 'src/assets/icons/cards/small/GoogleRSA';
import { GoogleSearchAdDescription as SmallGoogleSearchAdDescription } from 'src/assets/icons/cards/small/GoogleSearchAdDescription';
import { GoogleSearchHeadline as SmallGoogleSearchHeadline } from 'src/assets/icons/cards/small/GoogleSearchHeadline';
import { InstagramCaption as SmallInstagramCaption } from 'src/assets/icons/cards/small/InstagramCaption';
import { LandingPageBenefits as SmallLandingPageBenefits } from 'src/assets/icons/cards/small/LandingPageBenefits';
import { LandingPageCTA as SmallLandingPageCTA } from 'src/assets/icons/cards/small/LandingPageCTA';
import { LandingPageFeatures as SmallLandingPageFeatures } from 'src/assets/icons/cards/small/LandingPageFeatures';
import { LandingPageHeadline as SmallLandingPageHeadline } from 'src/assets/icons/cards/small/LandingPageHeadline';
import { LandingPageSubheader as SmallLandingPageSubheader } from 'src/assets/icons/cards/small/LandingPageSubheader';
import { LinkedinAd as SmallLinkedinAd } from 'src/assets/icons/cards/small/LinkedinAd';
import { LinkedinPost as SmallLinkedinPost } from 'src/assets/icons/cards/small/LinkedinPost';
import { NewDocument as SmallNewDocument } from 'src/assets/icons/cards/small/NewDocument';
import { OutbarainAdHeadline as SmallOutbarainAdHeadline } from 'src/assets/icons/cards/small/OutbarainAdHeadline';
import { PAS as SmallPAS } from 'src/assets/icons/cards/small/PAS';
import { PerfectProductHeadline as SmallPerfectProductHeadline } from 'src/assets/icons/cards/small/PerfectProductHeadline';
import { PinterestAd as SmallPinterestAd } from 'src/assets/icons/cards/small/PinterestAd';
import { PinterestPinDescription as SmallPinterestPinDescription } from 'src/assets/icons/cards/small/PinterestPinDescription';
import { PinterestPinTitle as SmallPinterestPinTitle } from 'src/assets/icons/cards/small/PinterestPinTitle';
import { ProductLandingPage as SmallProductLandingPage } from 'src/assets/icons/cards/small/ProductLandingPage';
import { ProductLaunchCampaign as SmallProductLaunchCampaign } from 'src/assets/icons/cards/small/ProductLaunchCampaign';
import { ProductReview as SmallProductReview } from 'src/assets/icons/cards/small/ProductReview';
import { PromotionalSMS as SmallPromotionalSMS } from 'src/assets/icons/cards/small/PromotionalSMS';
import { Prompt as SmallPrompt } from 'src/assets/icons/cards/small/Prompt';
import { SentenceExpander as SmallSentenceExpander } from 'src/assets/icons/cards/small/SentenceExpander';
import { SEOMetaDescription as SmallSEOMetaDescription } from 'src/assets/icons/cards/small/SEOMetaDescription';
import { Summarizer as SmallSummarizer } from 'src/assets/icons/cards/small/Summarizer';
import { TaboolaAdHeadline as SmallTaboolaAdHeadline } from 'src/assets/icons/cards/small/TaboolaAdHeadline';
import { TalkingPointsToParagraph as SmallTalkingPointsToParagraph } from 'src/assets/icons/cards/small/TalkingPointsToParagraph';
import { WalmartProductListings as SmallWalmartProductListings } from 'src/assets/icons/cards/small/WalmartProductListings';
import { WelcomeEmailDrip as SmallWelcomeEmailDrip } from 'src/assets/icons/cards/small/WelcomeEmailDrip';
import { XAd as SmallXAd } from 'src/assets/icons/cards/small/XAd';
import { XPost as SmallXPost } from 'src/assets/icons/cards/small/XPost';
import { YoutubeVideoDescription as SmallYoutubeVideoDescription } from 'src/assets/icons/cards/small/YoutubeVideoDescription';
import { Summarizer } from 'src/assets/icons/cards/Summarizer';
import { TaboolaAdHeadline } from 'src/assets/icons/cards/TaboolaAdHeadline';
import { TalkingPointsToParagraph } from 'src/assets/icons/cards/TalkingPointsToParagraph';
import { WalmartProductListings } from 'src/assets/icons/cards/WalmartProductListings';
import { WelcomeEmailDrip } from 'src/assets/icons/cards/WelcomeEmailDrip';
import { XAd } from 'src/assets/icons/cards/XAd';
import { XPost } from 'src/assets/icons/cards/XPost';
import { YoutubeVideoDescription } from 'src/assets/icons/cards/YoutubeVideoDescription';
import { YoutubeVideoTitle } from 'src/assets/icons/cards/YoutubeVideoTitle';
import { GENERATION_TOOL, GENERATION_TOOL_CARD_NEW_DOCUMENT } from 'src/data/generationTool';
import { isDocumentProjectType, isLongFormProjectType } from 'src/data/project';

const REGULAR_IMAGES = {
  // "basic" and "basic DD"
  [GENERATION_TOOL.basicContentImprover]: ContentImprover,
  [GENERATION_TOOL.basicEli5]: FifthGrader,
  [GENERATION_TOOL.basicSentenceExpander]: SentenceExpander,
  [GENERATION_TOOL.basicAida]: AIDA,
  [GENERATION_TOOL.basicPas]: PAS,
  [GENERATION_TOOL.basicPerfectHeadline]: PerfectProductHeadline,
  [GENERATION_TOOL.basicProductDescriptionList]: GeneralProductListing,
  [GENERATION_TOOL.basicProductDescriptionRelaxed]: GeneralProductListing,
  [GENERATION_TOOL.basicBlogIdeas]: BlogPostTopicIdes,
  [GENERATION_TOOL.basicTalkingPointsToParagraph]: TalkingPointsToParagraph,
  [GENERATION_TOOL.basicProductReview]: ProductReview,
  [GENERATION_TOOL.summarizer]: Summarizer,
  [GENERATION_TOOL.generalPrompt]: Prompt,

  // "data driven"
  [GENERATION_TOOL.facebookMixtureAd]: FacebookAd,
  [GENERATION_TOOL.facebookPrimaryTextProduct]: FacebookAd,
  [GENERATION_TOOL.facebookPrimaryTextProductRewrite]: FacebookAd,
  [GENERATION_TOOL.facebookHeadlineProduct]: FacebookAd,
  [GENERATION_TOOL.googleAppAd]: GoogleRSA,
  [GENERATION_TOOL.googleDemandGenAd]: GoogleRSA,
  [GENERATION_TOOL.googleDisplayAd]: GoogleRSA,
  [GENERATION_TOOL.googleShoppingAd]: GoogleRSA,
  [GENERATION_TOOL.googleVideoAd]: GoogleRSA,
  [GENERATION_TOOL.googleRSA]: GoogleRSA,
  [GENERATION_TOOL.googleDescriptionProduct]: GoogleSearchAdDescription,
  [GENERATION_TOOL.googleHeadlineProductRewrite]: GoogleSearchHeadline,
  [GENERATION_TOOL.googleDescriptionProductRewrite]: GoogleSearchAdDescription,
  [GENERATION_TOOL.googleHeadlineProduct]: GoogleSearchHeadline,
  [GENERATION_TOOL.googlePerformanceMaxAd]: GoogleSearchHeadline,
  [GENERATION_TOOL.outbrainAd]: OutbarainAdHeadline,
  [GENERATION_TOOL.outbrainHeadlineProduct]: OutbarainAdHeadline,
  [GENERATION_TOOL.outbrainHeadlineProductRewrite]: OutbarainAdHeadline,
  [GENERATION_TOOL.taboolaAd]: TaboolaAdHeadline,
  [GENERATION_TOOL.taboolaHeadlineProduct]: TaboolaAdHeadline,
  [GENERATION_TOOL.taboolaHeadlineProductRewrite]: TaboolaAdHeadline,
  [GENERATION_TOOL.twitterMixtureAd]: XAd,
  [GENERATION_TOOL.twitterCopyProduct]: XAd,
  [GENERATION_TOOL.twitterCopyProductRewrite]: XAd,
  [GENERATION_TOOL.twitterTitleProduct]: XAd,
  [GENERATION_TOOL.pinterestMixtureAd]: PinterestAd,
  [GENERATION_TOOL.pinterestDescriptionProduct]: PinterestPinDescription,
  [GENERATION_TOOL.pinterestDescriptionProductRewrite]: PinterestPinDescription,
  [GENERATION_TOOL.pinterestTitleProduct]: PinterestPinTitle,
  [GENERATION_TOOL.landingHeadline]: LandingPageHeadline,
  [GENERATION_TOOL.landingHeadlineRewrite]: LandingPageHeadline,
  [GENERATION_TOOL.landingSubheader]: LandingPageSubheader,
  [GENERATION_TOOL.landingSubheaderRewrite]: LandingPageSubheader,
  [GENERATION_TOOL.landingCTA]: LandingPageCTA,
  [GENERATION_TOOL.landingBenefits]: LandingPageBenefits,
  [GENERATION_TOOL.landingFeatures]: LandingPageFeatures,
  [GENERATION_TOOL.landingSEOMetadata]: SEOMetaDescription,
  [GENERATION_TOOL.landingSEOMetadataRewrite]: SEOMetaDescription,
  [GENERATION_TOOL.amazonProductListing]: AmazonProductListing,
  [GENERATION_TOOL.walmartProductListing]: WalmartProductListings,
  [GENERATION_TOOL.instagramCaption]: InstagramCaption,
  [GENERATION_TOOL.facebookPost]: FacebookPost,
  [GENERATION_TOOL.tweet]: XPost,
  [GENERATION_TOOL.linkedinPost]: LinkedinPost,
  [GENERATION_TOOL.linkedinPostRewrite]: LinkedinPost,
  [GENERATION_TOOL.pinterestMixturePost]: PinterestPinDescription,
  [GENERATION_TOOL.youtubeMixturePost]: YoutubeVideoDescription,
  [GENERATION_TOOL.pinterestPostDescription]: PinterestPinDescription,
  [GENERATION_TOOL.pinterestPostTitle]: PinterestPinTitle,
  [GENERATION_TOOL.youtubeTitle]: YoutubeVideoTitle,
  [GENERATION_TOOL.youtubeDescription]: YoutubeVideoDescription,
  [GENERATION_TOOL.emailSubjectLine]: EmailSubjectLine,
  [GENERATION_TOOL.emailPromotionalSubjectLine]: EmailSubjectLine,
  [GENERATION_TOOL.emailPromotionalBody]: Email,
  [GENERATION_TOOL.emailColdOutreachSubjectLine]: EmailSubjectLine,
  [GENERATION_TOOL.emailColdOutreachBody]: Email,
  [GENERATION_TOOL.emailColdOutreachBodyRewrite]: Email,
  [GENERATION_TOOL.emailPromotionalBodyRewrite]: Email,
  [GENERATION_TOOL.emailBodyRewrite]: Email,
  [GENERATION_TOOL.emailSubject]: EmailSubjectLine,
  [GENERATION_TOOL.emailBody]: Email,
  [GENERATION_TOOL.emailMixture]: Email,
  [GENERATION_TOOL.emailSubjectRewrite]: EmailSubjectLine,
  [GENERATION_TOOL.smsPromotional]: PromotionalSMS,
  [GENERATION_TOOL.smsPromotionalRewrite]: PromotionalSMS,
  [GENERATION_TOOL.facebookPrimaryTextContent]: FacebookAd,
  [GENERATION_TOOL.facebookHeadlineContent]: FacebookAd,
  [GENERATION_TOOL.outbrainHeadlineContent]: OutbarainAdHeadline,
  [GENERATION_TOOL.taboolaHeadlineContent]: TaboolaAdHeadline,
  [GENERATION_TOOL.twitterCopyContent]: XAd,
  [GENERATION_TOOL.pinterestDescriptionContent]: PinterestAd,
  [GENERATION_TOOL.pinterestTitleContent]: PinterestAd,
  [GENERATION_TOOL.generalProductListing]: GeneralProductListing,
  [GENERATION_TOOL.linkedinHeadlineSingleImageRewrite]: LinkedinAd,
  [GENERATION_TOOL.linkedinIntroSingleImageRewrite]: LinkedinAd,
  [GENERATION_TOOL.instagramCaptionRewrite]: InstagramCaption,
  [GENERATION_TOOL.facebookPostRewrite]: FacebookPost,
  [GENERATION_TOOL.pinterestPinTitleRewrite]: PinterestPinTitle,
  [GENERATION_TOOL.pinterestPinDescriptionRewrite]: PinterestPinDescription,
  [GENERATION_TOOL.tweetRewrite]: XPost,
  [GENERATION_TOOL.linkedinMixtureAd]: LinkedinAd,
  [GENERATION_TOOL.linkedinHeadlineSingleImage]: LinkedinAd,
  [GENERATION_TOOL.linkedinIntroSingleImage]: LinkedinAd,
  [GENERATION_TOOL.linkedinDocumentAd]: LinkedinAd,
  [GENERATION_TOOL.linkedinVideoAd]: LinkedinAd,
  [GENERATION_TOOL.linkedinTextAd]: LinkedinAd,
  [GENERATION_TOOL.linkedinMessageAd]: LinkedinAd,
  [GENERATION_TOOL.linkedinConversationAd]: LinkedinAd,
  [GENERATION_TOOL.linkedinLeadGenFormAd]: LinkedinAd,
  [GENERATION_TOOL.articleBlogHeadline]: Article,
  [GENERATION_TOOL.imageWithDescription]: ImageWithDescription,
  [GENERATION_TOOL.imageByStyle]: ImageWithDescription,

  // "Multi-prompt" tools
  [GENERATION_TOOL.productLaunchMultiPrompt]: ProductLaunchCampaign,
  [GENERATION_TOOL.landingPageProductAnnouncementMultiPrompt]: ProductLandingPage,
  [GENERATION_TOOL.emailDripMultiPrompt]: WelcomeEmailDrip,

  // Freestyle
  [GENERATION_TOOL.freestyle]: Prompt,
  [GENERATION_TOOL.createYourOwn]: Prompt,

  // "Blog" project type
  [GENERATION_TOOL.blogDescription]: BlogWizard,

  // "WTM" project type
  [GENERATION_TOOL.lpcoLandingHeadline]: LandingPageHeadline,
  [GENERATION_TOOL.lpcoLandingCTA]: LandingPageCTA,

  // "New" cards
  [GENERATION_TOOL_CARD_NEW_DOCUMENT]: NewDocument,
  [GENERATION_TOOL.longFormBlank]: NewDocument,
};

const SMALL_IMAGES = {
  // "basic" and "basic DD"
  [GENERATION_TOOL.basicContentImprover]: SmallContentImprover,
  [GENERATION_TOOL.basicEli5]: SmallFifthGrader,
  [GENERATION_TOOL.basicSentenceExpander]: SmallSentenceExpander,
  [GENERATION_TOOL.basicAida]: SmallAIDA,
  [GENERATION_TOOL.basicPas]: SmallPAS,
  [GENERATION_TOOL.basicPerfectHeadline]: SmallPerfectProductHeadline,
  [GENERATION_TOOL.basicProductDescriptionList]: SmallGeneralProductListing,
  [GENERATION_TOOL.basicProductDescriptionRelaxed]: SmallGeneralProductListing,
  [GENERATION_TOOL.basicBlogIdeas]: SmallBlogPostTopicIdes,
  [GENERATION_TOOL.basicTalkingPointsToParagraph]: SmallTalkingPointsToParagraph,
  [GENERATION_TOOL.basicProductReview]: SmallProductReview,
  [GENERATION_TOOL.summarizer]: SmallSummarizer,
  [GENERATION_TOOL.generalPrompt]: SmallPrompt,

  // "data driven"
  [GENERATION_TOOL.facebookMixtureAd]: SmallFacebookAd,
  [GENERATION_TOOL.facebookPrimaryTextProduct]: SmallFacebookAd,
  [GENERATION_TOOL.facebookPrimaryTextProductRewrite]: SmallFacebookAd,
  [GENERATION_TOOL.facebookHeadlineProduct]: SmallFacebookAd,
  [GENERATION_TOOL.googleAppAd]: SmallGoogleRSA,
  [GENERATION_TOOL.googleDemandGenAd]: SmallGoogleRSA,
  [GENERATION_TOOL.googleDisplayAd]: SmallGoogleRSA,
  [GENERATION_TOOL.googleShoppingAd]: SmallGoogleRSA,
  [GENERATION_TOOL.googleVideoAd]: SmallGoogleRSA,
  [GENERATION_TOOL.googleRSA]: SmallGoogleRSA,
  [GENERATION_TOOL.googleDescriptionProduct]: SmallGoogleSearchAdDescription,
  [GENERATION_TOOL.googleHeadlineProductRewrite]: SmallGoogleSearchHeadline,
  [GENERATION_TOOL.googleDescriptionProductRewrite]: SmallGoogleSearchAdDescription,
  [GENERATION_TOOL.googleHeadlineProduct]: SmallGoogleSearchHeadline,
  [GENERATION_TOOL.googlePerformanceMaxAd]: SmallGoogleSearchHeadline,
  [GENERATION_TOOL.outbrainHeadlineProduct]: SmallOutbarainAdHeadline,
  [GENERATION_TOOL.outbrainHeadlineProductRewrite]: SmallOutbarainAdHeadline,
  [GENERATION_TOOL.outbrainAd]: SmallOutbarainAdHeadline,
  [GENERATION_TOOL.taboolaAd]: SmallTaboolaAdHeadline,
  [GENERATION_TOOL.taboolaHeadlineProduct]: SmallTaboolaAdHeadline,
  [GENERATION_TOOL.taboolaHeadlineProductRewrite]: SmallTaboolaAdHeadline,
  [GENERATION_TOOL.twitterMixtureAd]: SmallXAd,
  [GENERATION_TOOL.twitterCopyProduct]: SmallXAd,
  [GENERATION_TOOL.twitterCopyProductRewrite]: SmallXAd,
  [GENERATION_TOOL.twitterTitleProduct]: SmallXAd,
  [GENERATION_TOOL.imageWithDescription]: SmallPrompt,
  [GENERATION_TOOL.imageByStyle]: SmallPrompt,
  [GENERATION_TOOL.pinterestMixtureAd]: SmallPinterestAd,
  [GENERATION_TOOL.pinterestDescriptionProduct]: SmallPinterestPinDescription,
  [GENERATION_TOOL.pinterestDescriptionProductRewrite]: SmallPinterestPinDescription,
  [GENERATION_TOOL.pinterestTitleProduct]: SmallPinterestPinTitle,
  [GENERATION_TOOL.landingHeadline]: SmallLandingPageHeadline,
  [GENERATION_TOOL.landingHeadlineRewrite]: SmallLandingPageHeadline,
  [GENERATION_TOOL.landingSubheader]: SmallLandingPageSubheader,
  [GENERATION_TOOL.landingSubheaderRewrite]: SmallLandingPageSubheader,
  [GENERATION_TOOL.landingCTA]: SmallLandingPageCTA,
  [GENERATION_TOOL.landingBenefits]: SmallLandingPageBenefits,
  [GENERATION_TOOL.landingFeatures]: SmallLandingPageFeatures,
  [GENERATION_TOOL.landingSEOMetadata]: SmallSEOMetaDescription,
  [GENERATION_TOOL.landingSEOMetadataRewrite]: SmallSEOMetaDescription,
  [GENERATION_TOOL.amazonProductListing]: SmallAmazonProductListing,
  [GENERATION_TOOL.walmartProductListing]: SmallWalmartProductListings,
  [GENERATION_TOOL.instagramCaption]: SmallInstagramCaption,
  [GENERATION_TOOL.facebookPost]: SmallFacebookPost,
  [GENERATION_TOOL.tweet]: SmallXPost,
  [GENERATION_TOOL.linkedinPost]: SmallLinkedinPost,
  [GENERATION_TOOL.linkedinPostRewrite]: SmallLinkedinPost,
  [GENERATION_TOOL.pinterestMixturePost]: SmallPinterestPinDescription,
  [GENERATION_TOOL.youtubeMixturePost]: SmallYoutubeVideoDescription,
  [GENERATION_TOOL.emailSubjectLine]: SmallEmailSubjectLine,
  [GENERATION_TOOL.emailPromotionalSubjectLine]: SmallEmailSubjectLine,
  [GENERATION_TOOL.emailPromotionalBody]: SmallEmail,
  [GENERATION_TOOL.emailColdOutreachSubjectLine]: SmallEmailSubjectLine,
  [GENERATION_TOOL.emailColdOutreachBody]: SmallEmail,
  [GENERATION_TOOL.emailColdOutreachBodyRewrite]: SmallEmail,
  [GENERATION_TOOL.emailPromotionalBodyRewrite]: SmallEmail,
  [GENERATION_TOOL.emailBodyRewrite]: SmallEmail,
  [GENERATION_TOOL.emailSubject]: SmallEmailSubjectLine,
  [GENERATION_TOOL.emailBody]: SmallEmail,
  [GENERATION_TOOL.emailMixture]: SmallEmail,
  [GENERATION_TOOL.emailSubjectRewrite]: SmallEmailSubjectLine,
  [GENERATION_TOOL.smsPromotional]: SmallPromotionalSMS,
  [GENERATION_TOOL.smsPromotionalRewrite]: SmallPromotionalSMS,
  [GENERATION_TOOL.facebookPrimaryTextContent]: SmallFacebookAd,
  [GENERATION_TOOL.facebookHeadlineContent]: SmallFacebookAd,
  [GENERATION_TOOL.outbrainHeadlineContent]: SmallOutbarainAdHeadline,
  [GENERATION_TOOL.taboolaHeadlineContent]: SmallTaboolaAdHeadline,
  [GENERATION_TOOL.twitterCopyContent]: SmallXAd,
  [GENERATION_TOOL.pinterestDescriptionContent]: SmallPinterestAd,
  [GENERATION_TOOL.pinterestTitleContent]: SmallPinterestAd,
  [GENERATION_TOOL.generalProductListing]: SmallGeneralProductListing,
  [GENERATION_TOOL.linkedinHeadlineSingleImageRewrite]: SmallLinkedinAd,
  [GENERATION_TOOL.linkedinIntroSingleImageRewrite]: SmallLinkedinAd,
  [GENERATION_TOOL.instagramCaptionRewrite]: SmallInstagramCaption,
  [GENERATION_TOOL.facebookPostRewrite]: SmallFacebookPost,
  [GENERATION_TOOL.pinterestPinTitleRewrite]: SmallPinterestPinTitle,
  [GENERATION_TOOL.pinterestPinDescriptionRewrite]: SmallPinterestPinDescription,
  [GENERATION_TOOL.tweetRewrite]: SmallXPost,
  [GENERATION_TOOL.linkedinMixtureAd]: SmallLinkedinAd,
  [GENERATION_TOOL.linkedinDocumentAd]: SmallLinkedinAd,
  [GENERATION_TOOL.linkedinVideoAd]: SmallLinkedinAd,
  [GENERATION_TOOL.linkedinTextAd]: SmallLinkedinAd,
  [GENERATION_TOOL.linkedinMessageAd]: SmallLinkedinAd,
  [GENERATION_TOOL.linkedinConversationAd]: SmallLinkedinAd,
  [GENERATION_TOOL.linkedinLeadGenFormAd]: SmallLinkedinAd,
  [GENERATION_TOOL.linkedinHeadlineSingleImage]: SmallLinkedinAd,
  [GENERATION_TOOL.linkedinIntroSingleImage]: SmallLinkedinAd,
  [GENERATION_TOOL.articleBlogHeadline]: SmallArticle,

  // "Multi-prompt" tools
  [GENERATION_TOOL.productLaunchMultiPrompt]: SmallProductLaunchCampaign,
  [GENERATION_TOOL.landingPageProductAnnouncementMultiPrompt]: SmallProductLandingPage,
  [GENERATION_TOOL.emailDripMultiPrompt]: SmallWelcomeEmailDrip,

  // Freestyle
  [GENERATION_TOOL.freestyle]: SmallPrompt,
  [GENERATION_TOOL.createYourOwn]: SmallPrompt,

  // "Blog" project type
  [GENERATION_TOOL.blogDescription]: SmallBlogWizard,

  // "WTM" project type
  [GENERATION_TOOL.lpcoLandingHeadline]: SmallLandingPageHeadline,
  [GENERATION_TOOL.lpcoLandingCTA]: SmallLandingPageCTA,

  // "New" cards
  [GENERATION_TOOL_CARD_NEW_DOCUMENT]: SmallNewDocument,
  [GENERATION_TOOL.longFormBlank]: SmallNewDocument,
};

const LONG_FORM_IMAGES = {
  [GENERATION_TOOL.customMultiPrompt]: LongFormSavedTemplate,
};

const SHORT_FORM_IMAGES = {
  [GENERATION_TOOL.customMultiPrompt]: ShortFormSavedTemplate,
};

export const getGenerationToolCardImage = ({ projectType, tool }, { small }) => {
  const defaultIcon = small ? SmallPrompt : Prompt;
  const icons = small ? SMALL_IMAGES : REGULAR_IMAGES;

  const longFormIcon = isLongFormProjectType(projectType) && LONG_FORM_IMAGES[tool];
  const shortFormIcon = isDocumentProjectType(projectType) && SHORT_FORM_IMAGES[tool];

  if (longFormIcon) {
    return longFormIcon;
  }

  if (shortFormIcon) {
    return shortFormIcon;
  }

  return icons[tool] || defaultIcon;
};
